import { Injectable } from '@angular/core'
import { LocalStorageService } from './local-storage.service'

@Injectable({
  providedIn: 'root',
})
export class DataService {
  constructor(private localStorageService: LocalStorageService) {}

  private _getFirstYear(): number {
    return 2022
  }

  getCurrentYear(): number {
    return new Date().getFullYear()
  }

  private setCachedYear(key: string, year: number) {
    if (Number.isInteger(year)) this.localStorageService.set(key, year)
  }

  private getCachedYear(key: string): number {
    let year = this.localStorageService.get(key)
    return Number.isInteger(year) ? year : new Date().getFullYear()
  }

  setCachedYearSince2019 = (year: number) => this.setCachedYear('year-since-2019.opt', year)
  getCachedYearSince2019 = () => this.getCachedYear('year-since-2019.opt')

  setCachedYearSince2022 = (year: number) => this.setCachedYear('year-since-2022.opt', year)
  getCachedYearSince2022 = () => this.getCachedYear('year-since-2022.opt')

  listYearsSince2022(): number[] {
    return [...Array(this.getCurrentYear() - this._getFirstYear() + 1).keys()].map(i => i + this._getFirstYear())
  }

  listYearsSince2019(): number[] {
    return [...Array(this.getCurrentYear() - 2019 + 1).keys()].map(i => i + 2019)
  }
}
